import { Value } from '@ui/features/Trade/types';
import { create } from 'zustand';

type InputState = {
  input: {
    value: Value;
  };
  setInput: (input: InputState['input']) => void;
  reset: () => void;
};

export const useWithdrawCollateralInput = create<InputState>((set) => ({
  input: {
    value: {
      usd: null,
      token: null,
    },
  },
  reset: () => set({ input: { value: { usd: null, token: null } } }),
  setInput: (input) => set({ input }),
}));
